import entries from 'lodash/entries';

export const setSelected = (arr, value) =>
    arr.map(item =>
        (item.value === value ? { ...item, selected: true } : item)
    );

export const getOption = category =>
    (category.options || []).find(item => item.selected) || {};

export const getOptions = (categories) => {
    const res = {};
    entries(categories).forEach(([key, category]) => {
        res[key] = getOption(category);
    });
    return res;
};

export const getLabel = category =>
    getOption(category).label;

export const getLabels = (categories) => {
    const res = {};
    entries(categories).forEach(([key, category]) => {
        res[key] = getLabel(category);
    });
    return res;
};

export const getStatusLabel = (category) => {
    const { statusLabel, label } = getOption(category);
    return statusLabel || label;
};

export const getStatusLabels = (categories) => {
    const res = {};
    entries(categories).forEach(([key, category]) => {
        res[key] = !category.isHidden ? getStatusLabel(category) : null;
    });
    return res;
};

export const getValue = category =>
    getOption(category).value;

export const getValues = (categories) => {
    const res = {};
    entries(categories).forEach(([key, category]) => {
        res[key] = getValue(category);
    });
    return res;
};

export default {
    setSelected,
    getOption,
    getOptions,
    getLabel,
    getLabels,
    getStatusLabel,
    getStatusLabels,
    getValue,
    getValues
};




// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/selection.js